/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AppointmentBooking from './AppointmentBooking/index'
import AppointmentNotes from './AppointmentNotes/index'
import BasicInformation from './BasicInformation/index'
import ExternalProfessionals from './ExternalProfessionals/index'
import PaymentOverdue from './PaymentOverdue/index'
import PracticeHub from './PracticeHub/index'
import React from 'react'
import Relations from './Relations/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<BasicInformation
  viewPath={`${viewPath}/BasicInformation`}
/>
<AppointmentBooking
  viewPath={`${viewPath}/AppointmentBooking`}
/>
<PaymentOverdue
  viewPath={`${viewPath}/PaymentOverdue`}
/>
<PracticeHub
  viewPath={`${viewPath}/PracticeHub`}
/>
<Relations
  viewPath={`${viewPath}/Relations`}
/>
<ExternalProfessionals
  viewPath={`${viewPath}/ExternalProfessionals`}
/>
<AppointmentNotes
  viewPath={`${viewPath}/AppointmentNotes`}
/>
</div>
{children}
</React.Fragment>)
}